export const ASSETS = {
    // The HC Hopewell Consulting logo (cleaner refreshed brand mark)
    logo: "https://customer-assets.emergentagent.com/job_hopewell-consulting/artifacts/9s9fcn2t_IMG_20260612_110706.png",
    // Legacy HWC logo retained for reference
    logoLegacy: "https://customer-assets.emergentagent.com/job_dee25039-ed43-4609-9de0-860c7eb6797e/artifacts/ur6015v8_IMG_20260608_120124%20%284%29.png",
    // Reico's resume (kept for reference, not used in UI)
    reicoResume:
        "https://customer-assets.emergentagent.com/job_dee25039-ed43-4609-9de0-860c7eb6797e/artifacts/4fbqo833_IMG_20260608_120123.png",
    // Clean isolated headshot of Reico — navy suit, dark studio background
    reicoHeadshot:
        "https://customer-assets.emergentagent.com/job_hopewell-consulting/artifacts/sx2nuh1s_IMG_6271%20%281%29.png",
    // Full executive flyer (kept for reference / About bio section)
    reicoFlyer:
        "https://customer-assets.emergentagent.com/job_dee25039-ed43-4609-9de0-860c7eb6797e/artifacts/xrutsat1_IMG_20260608_120124%20%283%29.png",
    // "What Does Hopewell Consulting Do?" watercolor poster — brand showcase
    brandPoster:
        "https://customer-assets.emergentagent.com/job_dee25039-ed43-4609-9de0-860c7eb6797e/artifacts/38u27sri_IMG_20260608_120123%20%282%29.png",
    watercolorSkyline:
        "https://customer-assets.emergentagent.com/job_dee25039-ed43-4609-9de0-860c7eb6797e/artifacts/38u27sri_IMG_20260608_120123%20%282%29.png",
    // Sponsors/Supporters collage from The HopeWell Foundation — features 60+ partner logos
    sponsorsCollage:
        "https://customer-assets.emergentagent.com/job_hopewell-consulting/artifacts/bccfl3id_IMG_20260609_083457.png",
    knoxvilleSkyline:
        "https://images.unsplash.com/photo-1627918460126-a43223e9be9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
    consultingMeeting:
        "https://customer-assets.emergentagent.com/job_hopewell-consulting/artifacts/xef4yzwl_IMG_20260614_174014.jpg",
    communityVolunteer:
        "https://customer-assets.emergentagent.com/job_hopewell-consulting/artifacts/g0het0t2_IMG_20260614_182410.jpg",
    construction:
        "https://customer-assets.emergentagent.com/job_hopewell-consulting/artifacts/exn6gowz_IMG_20260614_151548.jpg",
    propertyDevelopment:
        "https://customer-assets.emergentagent.com/job_hopewell-consulting/artifacts/exn6gowz_IMG_20260614_151548.jpg",
    aerialBeforeAfter:
        "https://customer-assets.emergentagent.com/job_hopewell-consulting/artifacts/exn6gowz_IMG_20260614_151548.jpg",
    boardroom:
        "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};

export const SITE = {
    name: "Hopewell Consulting LLC",
    shortName: "Hopewell Consulting",
    tagline: "Turning Vision Into Reality",
    phone: "865-951-8347",
    phoneLink: "+18659518347",
    email: "reico85@gmail.com",
    address: "Knoxville, Tennessee",
    serviceAreas: ["Tennessee", "Connecticut", "Georgia", "North Carolina", "Texas"],
    serviceAreasShort: "TN · CT · GA · NC · TX",
    facebook: "https://www.facebook.com/share/1CmNKSDVpv/",
    instagram:
        "https://www.instagram.com/mr.reicohope?igsh=MXZ5NnNlN3pmdHoxdA==",
};

export const CREDENTIALS = [
    { label: "SAP", title: "Substance Abuse Professional" },
    { label: "QCS", title: "Qualified Clinical Supervisor" },
    { label: "LADAC II", title: "Licensed Alcohol & Drug Abuse Counselor" },
    { label: "NCAC I", title: "National Certified Addiction Counselor" },
];

export const TRUST_POINTS = [
    "TN · CT · GA · NC · TX",
    "Business Formation",
    "Nonprofit Development",
    "Real Estate Strategy",
    "Grant Writing",
    "Brand Development",
];

export const VENTURES = [
    {
        name: "The HopeWell Foundation",
        role: "Founder & Executive Director",
        blurb: "Resources, recovery services, workforce development, and community empowerment.",
        url: "https://www.thehopewell.info",
    },
    {
        name: "HopeWell A&D Counseling",
        role: "Founder & CEO",
        blurb: "Assessments, individual, family, and group counseling. DOT/SAP evaluations.",
        url: "https://www.hopewellad.com",
    },
    {
        name: "Hopewell Consulting LLC",
        role: "CEO",
        blurb: "Business formation, nonprofit development, grant writing, branding, and leadership training.",
        url: "",
    },
    {
        name: "The Mend House",
        role: "Co-Founder",
        blurb: "Recovery housing serving 700+ men since 2015 — accountability, counseling, employment, stability.",
        url: "https://www.themendhouse.org",
    },
    {
        name: "Hopewell Helping Hands",
        role: "Owner",
        blurb: "Employment opportunities, workforce development, and pathways to self-sufficiency.",
        url: "https://www.hopewellhelpinghands.com",
    },
];

export const PILLARS = [
    { label: "Strategy", text: "Clarity on what to do next, and why." },
    { label: "Structure", text: "Systems, governance, and documents that hold up under scrutiny." },
    { label: "Results", text: "Funded programs, launched businesses, and lasting community impact." },
];

export const REICO_QUOTE = {
    text: "I believe that true success is measured not by what we accumulate for ourselves, but by what we create for others. Every life transformed, every business launched, every person in recovery, every scholarship awarded, and every opportunity created strengthens our community for future generations.",
    author: "Reico S. Hopewell",
};
